import swaggerClient from "./../remote-client";
import Utils from "../Utils";

export default class OperatorsManagementService {
  /**
   * @param  {} officeId
   */
  fetchOperators(reqParams) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityUserManagement.getUsersOfficeWithId(
            reqParams,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.userList;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  /**
   * @param  {} officeId
   */
  fetchHfUsers(params) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityUserManagement.getUsersHfWithHfIdOfficeWithOfficeId(
            {
              hfId: params.hfId,
              officeId: params.officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.userList;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  /**
   * @param  {} user
   */
  createNewUser(officeId, user) {
    user["idRiferimentoOperativoInCRM"] = "UNDEFINED-string"; // add extra field and assign value in operator object
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityUserManagement.postUserOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(user),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }
  updateUser(officeId, user) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityUserManagement.postUserOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(user),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function () {
          return user;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }
  deleteUser(officeId, userId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityUserManagement.deleteUserWithUserIdOfficeWithId(
            {
              id: officeId,
              userId: userId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }
  resendUserToken(officeId, userId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityUserManagement.postResendMailToOperatorUserWithUserIdOfficeWithId(
            {
              id: officeId,
              userId: userId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }
}
